import React from 'react';
import styles from './FieldLinkComponent.module.scss';
import { Link } from '@jutro/router';

import { FieldComponent } from '@jutro/legacy/components';

import { TranslatorContext } from '@jutro/legacy/locale';

class FieldLinkComponent extends FieldComponent {
    static contextType = TranslatorContext;

    static propTypes = {
        ...FieldComponent.propTypes,
    };

    renderControl() {
        const { value } = this.props;
        return (
            <Link className={styles.fieldLinkColor} {...this.props}>
                {value}
            </Link>
        );
    }

    render() {
        return super.render();
    }
}

export default FieldLinkComponent;
